import { ref } from "vue"

export function useFilter() {
  var result = ref([])
    function filterData(dataArray, searchQuery) {
      result.value = []
      const condition = new RegExp(searchQuery, 'gi')  
      const keyArr = Object.keys(dataArray[0]) 
      dataArray.forEach((e) => {
          for (let index = 0; index < keyArr.length; index++) {          
            if( typeof(e[keyArr[index]])=='string' && (e[keyArr[index]]).match(condition)){
              result.value.push(e);
              break;
            }          
          }
        });  
    }
    return {
      filterData, 
      result,
    };
}